import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Button, Table, Container, Spinner } from 'react-bootstrap';

import { fetchSplashScreens } from '../../../store/actions/splashscreens/splashScreenActions'

import PageTitle from '../../../common/PageTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import { capitalize } from '../../../common/Utilities';

class SplashScreens extends Component {

  componentDidMount() {
    this.props.fetchSplashScreens();
  }
  
  renderSplashScreens = () => {
    let splashscreens = this.props.splashscreens.splashscreens;

    let splashscreenList = [];

    if (splashscreens) {
      splashscreenList = splashscreens.length ? (
        splashscreens.sort(function(a,b) { return a.sequence - b.sequence } ).map((splashscreen, key) => {

          return (
            <tr key={key}>
              <td>{splashscreen.label}</td>
              <td>{splashscreen.description}</td>
              <td><img alt={splashscreen.label} src={splashscreen.image} /></td>
              <td className="align-center">{splashscreen.sequence}</td>
              <td className="align-center">{capitalize(splashscreen.status.name)}</td>
              <td className="align-center">{splashscreen.updated_at}</td>
              <td className="align-center">
                <div className="align-center action-btns">
                  <Button size="sm" className="btn-icon ml-3" onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push('/splash-screens/edit?id=' + splashscreen.id)
                  }}>
                    <FontAwesomeIcon icon={faPen} /> Edit 
                  </Button>
                </div>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={7}><Spinner animation="border" size="sm" /></td>
        </tr>
      )
    }
    else {
      return (
        <tr>
          <td colSpan={7}><p className="text-danger">No splashscreens found.</p></td>
        </tr>
      )
    }

    return splashscreenList;
  }

  render() {
    const upsertSplashScreen = <Button id="add-client" size="md" onClick={() => {
        this.props.history.push('/splash-screens/new')
    }}>Add Splash Screen</Button>
    

    return (
      <div>
        <Container className="waa-container">
            <PageTitle pageName="SPLASH SCREENS" actionButton={upsertSplashScreen} />
            <Row>
                <Table className="waa-table splashscreens">
                    <thead>
                        <tr>
                            <th>SCREEN LABEL</th>
                            <th>DESCRIPTION</th>
                            <th>IMAGE</th>
                            <th>SEQUENCE</th>
                            <th>STATUS</th>
                            <th>LAST UPDATED</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                    { this.renderSplashScreens() }
                  </tbody>
                </Table>
            </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  splashscreens: state.splashscreens,
})

const mapDispatchToProps = (dispatch) => ({
  fetchSplashScreens: (...args) => dispatch(fetchSplashScreens(...args))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SplashScreens))